import { createContext, FC, PropsWithChildren } from 'react'

import { usePromptProvider } from './hooks/usePromptProvider'

export const PromptContext = createContext<
  ReturnType<typeof usePromptProvider> | undefined
>(undefined)

export const PromptProvider: FC<PropsWithChildren> = props => {
  const value = usePromptProvider()

  return <PromptContext.Provider value={value}>{props.children}</PromptContext.Provider>
}
